<template>
  <div class="reports">
    <ReportPlayerWinloseComponent
      :ref-key-text="refKeyText"
      :title="title"
      :url-path="urlPath"
      :route-name="routeName"
      :is-simple="true"
      :is-search-username="true"
    />
  </div>
</template>

<script>
import ReportPlayerWinloseComponent from '@/components/ReportPlayerWinloseComponent.vue'

export default {
  components: {
    ReportPlayerWinloseComponent,
  },
  data() {
    return {
      refKeyText: 'Username',
      title: 'W/L Player (Simple)',
      urlPath: '/reports/v2/player_winlose_simple',
      routeName: 'reports-player-winlose-simple',
    }
  },
}
</script>

<style>

</style>
